import { Component, OnInit, ViewChild } from '@angular/core'
import { CdkOverlayOrigin, ConnectedPosition } from '@angular/cdk/overlay'
import { isFunction } from 'lodash'
import { RoutingService } from '@tv3/services/routing.service'

declare const window: any

@Component({
  selector: 'app-help-widget',
  templateUrl: './help-widget.component.html',
  styleUrls: ['./help-widget.component.scss'],
})
export class HelpWidgetComponent implements OnInit {
  public open = false
  isFirstPaid$ = this.routingService.isFirstPaid()

  @ViewChild('helpTrigger') helpTrigger: CdkOverlayOrigin

  menuPositions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'start', overlayY: 'bottom' },
    { originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top' },
  ]

  constructor(private routingService: RoutingService) {}

  ngOnInit() {}

  // The trigger's own (click) toggles the menu. The same click also reaches the
  // overlay's outside-click dispatcher, so ignore it there to avoid the two
  // handlers cancelling each other out.
  onOutsideClick(event: MouseEvent) {
    if (this.helpTrigger?.elementRef.nativeElement.contains(event.target as Node)) {
      return
    }
    this.open = false
  }

  goToScheduleTraining() {
    window.open('https://calendly.com/tokeet')
  }

  goToHelp() {
    window.open('https://advance.cm/help')
  }

  goToCommunity() {
    window.open('https://community.tokeet.com/')
  }

  goToTokeetStatus() {
    window.open('https://status.tokeet.com/')
  }

  goToOnboarding() {
    window.open('https://calendly.com/tokeet-success/onboarding-call')
  }

  goToDemo() {
    window.open('https://calendly.com/tokeet-success/initial-training')
  }

  openChat() {
    if (isFunction(window.Intercom)) {
      window.Intercom('show')
    }
    this.open = false
  }
}
